/**
 * アニメーション関連の処理
 */
export default class Motion {
	constructor() {
		this.faqSlide()
		this.categorySlide()
		this.navButton()
		this.navSublistToggle()
		this.menuSublistToggle()
		this.scrollToggle()
		this.fileItemToggle()
		this.selectAnchor()
	}
	faqSlide() {
		$('.c-service-faq__item').on('click', function () {
			$(this).children('.c-service-faq__item-que').toggleClass('is-active')
			$(this).children('.js-slide').slideToggle()
		});
	}

	categorySlide() {
		$('.p-acvh-category__heading').on('click', function () {
			$(this).toggleClass('is-active')
			$(this).next('.p-acvh-category__list').slideToggle()
		});
	}

	navButton() {
		$('.js-nav-toggle').on('click', function () {
			$('.l-header-nav').fadeToggle();
		});
	}

	navSublistToggle() {
		$('.js-item-toggle').on('click', function () {
			$(this).parent('.l-nav-sp__list-item').toggleClass('is-active')
			$(this).next('.l-nav-sp__sublist').slideToggle()
		});
	}

	menuSublistToggle() {
		$(".js-menu-toggle").hover(function () {
			$(this).children(".js-menu-target").stop().fadeToggle();
			$(this).children(".l-header-menu__link").toggleClass('is-active');
		});
	}

	scrollToggle() {
		$(window).on('scroll load', function () {
			if ($(window).scrollTop() > 0) {
				$('.l-header-logo').addClass('is-scrolled');
				$('.c-top-anchor').addClass('is-scrolled');
			} else {
				$('.l-header-logo').removeClass('is-scrolled');
				$('.c-top-anchor').removeClass('is-scrolled');
			}
		});
	}

	fileItemToggle() {
		$('.js-next-toggle').on('click', function () {
			$(this).next('.js-next-target').slideToggle();
			//$('.js-next-toggle').not(this).next('.js-next-target').hide();
			$(this).toggleClass('is-active');
		});
	}

	selectAnchor() {
		$('.js-select-anchor').change(function () {
			var speed = 400;
			var href = $(this).val();
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$('body,html').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	}
}